import { render, staticRenderFns } from "./CourseHomeView.vue?vue&type=template&id=1982778c&scoped=true&"
import script from "./CourseHomeView.vue?vue&type=script&lang=js&"
export * from "./CourseHomeView.vue?vue&type=script&lang=js&"
import style0 from "./CourseHomeView.vue?vue&type=style&index=0&id=1982778c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1982778c",
  null
  
)

/* custom blocks */
import block0 from "./CourseHomeView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports